"use client";

import dynamic from "next/dynamic";

const AdminBarClient = dynamic(() => import("./AdminBarClient").then(mod => mod.AdminBarClient), { ssr: false });

export default AdminBarClient;
